/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  HostListener,
  inject,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FileUploadService } from '../../../pages/documents/services/file-upload.service';
import { UploadItem } from '../../models/upload-item';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-upload-progress',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './upload-progress.component.html',
  styleUrls: ['./upload-progress.component.scss'],
})
export class UploadProgressComponent {
  fileUploadService = inject(FileUploadService);
  private elementRef = inject(ElementRef);
  private renderer = inject(Renderer2);
  uploads$: Observable<UploadItem[]> = this.fileUploadService.uploads$;
  isMinimized = false;
  isHidden = false;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    if (this.fileUploadService.activeUploadsCount > 0) {
      $event.returnValue = true;
    }
  }

  minimizeToHeader(): void {
    const container = this.elementRef.nativeElement.querySelector(
      '.upload-progress-container',
    );
    if (!container) return;

    // Get the upload indicator position in the header
    const uploadIndicator = document.querySelector('.upload-indicator');
    if (!uploadIndicator) {
      // Fallback if indicator not found
      this.isHidden = true;
      return;
    }

    const indicatorRect = uploadIndicator.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    // Calculate the translation needed - adjust to center of upload indicator
    const translateX =
      indicatorRect.left +
      indicatorRect.width / 2 -
      (containerRect.left + containerRect.width / 2);
    const translateY =
      indicatorRect.top + indicatorRect.height / 2 - containerRect.top;

    // Add minimizing class and apply transform
    this.renderer.addClass(container, 'minimizing');
    this.renderer.setStyle(
      container,
      'transform',
      `translate(${translateX}px, ${translateY}px) scale(0)`,
    );

    // Hide after animation completes
    setTimeout(() => {
      this.isHidden = true;
      this.renderer.removeClass(container, 'minimizing');
      this.renderer.removeStyle(container, 'transform');
    }, 400);
  }

  closeUploadProgress(): void {
    this.isHidden = true;
  }

  showProgress(): void {
    this.isHidden = false;
  }

  cancelUpload(uploadId: string): void {
    this.fileUploadService.cancelUpload(uploadId);
  }

  get activeUploadsCount(): number {
    return this.fileUploadService.activeUploadsCount;
  }
}
